import { useState } from "react";
import { useNavigate } from "react-router";
import { PasscodeForm } from "@/components/auth/PasscodeForm";
import { ShareLink } from "@/components/auth/ShareLink";

export function Register() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [jwt, setJwt] = useState<string | null>(null);

  const handleSubmit = async (passcode: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passcode }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);

      setJwt(data.jwt);

      // Store in session
      sessionStorage.setItem(
        "choreapp_passcode",
        JSON.stringify({
          role: "admin",
          jwt: data.jwt,
          passcode,
          user: { _key: data.jwt, name: "Admin", icon: "👑", description: "" },
        }),
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  if (jwt) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-app-bg p-4 gap-4 md:gap-6">
        <div className="text-center mb-2">
          <h1 className="text-heading font-bold mb-1">🎉 You're all set!</h1>
          <p className="text-body text-app-text-muted">
            Save the link below — it's your only way to access the admin panel.
          </p>
        </div>

        <div className="w-full max-w-md">
          <ShareLink
            url={`/admin/${jwt}/dashboard`}
            title="Admin Access Link"
            description="Bookmark this or save it somewhere safe. Anyone with this link + your passcode can access your admin panel."
          />
        </div>

        <button
          className="text-body text-app-primary hover:underline mt-2"
          onClick={() => navigate(`/admin/${jwt}/dashboard`)}
        >
          Go to Dashboard →
        </button>
      </div>
    );
  }

  return (
    <PasscodeForm
      mode="setup"
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
    />
  );
}
